import { AdminApi } from 'stylemix-vue-admin'

export default class ApplicationApi extends AdminApi {
  constructor(parameters) {
    super('company-applications', parameters)
  }

  all(config = {}) {
    return this.submit('get', `/${this.endpoint}`, config)
  }

  accept(item) {
    return this.submit('post', `/${this.endpoint}/${item.id}/accept`, item)
  }

  getVehicles(address, rideTypes, deliveryAreaCenter, airports) {
    this.setParameters({ address, ride_types: rideTypes, delivery_area_center: deliveryAreaCenter, airports })
    return this.submit('get', `/${this.endpoint}/vehicles`).then(result => {
      this.removeParameters(['address', 'ride_types', 'delivery_area_center', 'airports'])

      return result
    })
  }

  checkEmail(email) {
    this.setParameters({email})
    return this.submit('post', `/${this.endpoint}/check/email`).then(result => {
      this.removeParameters(['email']);
      return result
    });
  }
}
